import React from 'react';
import { useNavigate } from 'react-router-dom';

const withNavigate = (Component) => {
  return (props) => {
    const navigate = useNavigate();
    
    // Create a history-like object for backward compatibility
    const history = {
      push: (path) => navigate(path),
      replace: (path) => navigate(path, { replace: true }),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
    };
    
    return <Component {...props} navigate={navigate} history={history} />;
  };
};

export default withNavigate;
